import React from 'react';
import {Page, Text, View, Document, Font} from '@react-pdf/renderer';
import {withTranslation} from "react-i18next";
import {EXT_TITLE, VERSION} from "../../../../config/consts";
import {styles} from "./styles";
import font from "../../../../assets/fonts/arial-unicode-ms.ttf";
import config from "../../../../config/config";
import Html from "react-pdf-html";

Font.register({
  family: 'pdfFont',
  src: font
});
Font.registerEmojiSource({
  format: 'png',
  url: 'https://twemoji.maxcdn.com/2/72x72/',
});

const stylesheet = {
  ['.ai-chat-container']: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  ['.ai-icon-restart']: {
    display: 'none',
  },
  ['.ai-message-user']: {
    paddingTop: '100px',
    //alignSelf: "flex-end",
    //maxWidth: '60%'
  },
  ['.ai-message-bot']: {
    paddingTop: '30px',
    //alignSelf: "flex-start",
    //maxWidth: '60%'
  },
  ['.ai-bubble-user']: {
    padding: '12px 16px',
    borderRadius: '18px',
    backgroundColor: "#0078ff",
    color: "white",
    whiteSpace: "pre-wrap",
  },
  ['.ai-bubble-bot']: {
    padding: '12px 16px',
    borderRadius: '18px',
    backgroundColor: "#e0e0e0",
    color: "black",
    whiteSpace: "normal",
  }
};

const ExportPdfProfilerAI = ({t, data: exportData}) => {
  const exportHtml = `${exportData?.assistantMessage}${exportData?.chatHtml}`;
  console.log('exportHtmnlk', exportHtml);
  return (
    <Document>
      <Page style={styles.body}>
        <Text style={styles.header} fixed>{t("Created by")} {config.appTitle || EXT_TITLE} {VERSION}</Text>
        <View style={styles.headerPadding} fixed/>


        <Html stylesheet={stylesheet}>{exportHtml}</Html>

        <Text style={styles.pageNumber} render={({pageNumber, totalPages}) => (
          `${pageNumber} / ${totalPages}`
        )} fixed/>
      </Page>
    </Document>
  )
};


export default withTranslation()(ExportPdfProfilerAI);